import React from 'react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { audienceLabels, volumes, volumesSection } from '../data/content';
export function Volumes() {
  return <section aria-labelledby="volumes-heading" className="w-full bg-ivory px-5 py-14 md:px-8 md:py-24" data-id="element-196" data-mp="184ey7rx3ey2q">
      <div className="mx-auto w-full max-w-content" data-id="element-197" data-mp="1c6a1h1yl3lj5">
        <Reveal data-id="element-198" data-mp="1zv1kp3u74tjs">
          <SectionHeading id="volumes-heading" title={volumesSection.title} data-id="element-199" data-mp="1zujjrtwl9r5j" />
        </Reveal>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4 md:mt-14" data-id="element-200" data-mp="24unzvitl4jv8">
          {volumes.map((volume, index) => <Reveal as="li" key={volume.number} delay={index % 4 * 0.04} className="h-full" data-id="element-201" data-mp="1qtlbgzf4axh5" data-mpi={index}>
                <article className="flex h-full flex-col rounded-xl border border-charcoal/10 bg-white p-6 shadow-[0_1px_2px_rgba(32,41,35,0.06)]" data-id="element-202" data-mp="1vsen0maugeeo">
                  <div className="flex items-baseline justify-between border-b border-brass/50 pb-4" data-id="element-203" data-mp="fhkfp0ju68rw">
                    <span className="text-[13px] font-semibold uppercase tracking-[0.14em] text-charcoal/70" data-id="element-204" data-mp="3o86nkfg5vya6">
                      Volume
                    </span>
                    <span className="font-serif text-4xl font-medium leading-none text-forest" data-id="element-205" data-mp="3jawp6aasoca7">
                      {volume.number}
                    </span>
                  </div>
                  <h3 className="mt-5 font-serif text-[1.5rem] font-semibold leading-[1.15] text-charcoal" data-id="element-206" data-mp="3t6gkauhjb6xw">
                    {volume.title}
                  </h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-charcoal/75 md:text-base" data-id="element-207" data-mp="633degbc8w2w">
                    {volume.benefit}
                  </p>
                  <ul className="mt-auto space-y-2 pt-5" data-id="element-208" data-mp="kqojmj3ifbf1">
                    {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3 text-[15px] leading-snug text-charcoal" data-id="element-209" data-mp="fupmo7448l30">
                        <span aria-hidden="true" className="mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-brass" data-id="element-210" data-mp="pog7n211addy" />
                        {bullet}
                      </li>)}
                  </ul>
                </article>
            </Reveal>)}
        </ul>

        <Reveal delay={0.04} data-id="element-211" data-mp="1bjovdqd18etq">
          <div className="mt-12 flex flex-col items-center gap-5 text-center md:mt-14" data-id="element-212" data-mp="1bjydkrru5hov">
            <p className="font-serif text-2xl font-medium text-charcoal" data-id="element-213" data-mp="1fjp8n7oeajz7">
              {volumesSection.footnote}
            </p>
            <ul className="flex flex-wrap items-center justify-center gap-2.5" data-id="element-214" data-mp="1kl4taymnuoh2">
              {audienceLabels.map(label => <li key={label} className="rounded-full border border-forest/20 bg-white px-4 py-2 text-sm font-medium text-forest" data-id="element-215" data-mp="1ui145b017mos">
                  {label}
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}